export default {
  graphicsLoader: {
    type: Boolean,
  },
  value: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: () => String(''),
  },
  title: {
    type: String,
    default: () => String('KPI'),
  },
  ...[
    'lspList',
    'languagesList',
    'qaMethodsList',
    'qaModelsList',
    'textCategoryList',
    'industryFieldList',
    'graphicsData',
  ].reduce((acc, key) => {
    acc[key] = {
      type: Array,
      required: true,
    };
    return acc;
  }, Object()),
};
